module.exports = __webpack_public_path__ + "img/app_all2.39589907.png";